import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService,
        private toastController: ToastController,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        //const token = "my-token-string-from-server";

        //Authentication by setting header with token value
        /*if (token) {
          request = request.clone({
            setHeaders: {
              'Authorization': token
            }
          });
        }*/

        /*if (!request.headers.has('Content-Type')) {
          request = request.clone({
            setHeaders: {
              'content-type': 'application/json'
            }
          });
        }*/

        /*request = request.clone({
          headers: request.headers.set('Accept', 'application/json')
        });*/

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    console.log('event--->>>', event);
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 402) {
                    this.authenticationService.logout();
                    this.router.navigateByUrl('/login', { replaceUrl: true });
                    this.showMessageHttp('Su suscripción ha caducado');
                }
                if (error.status === 401) {
                    this.authenticationService.logout();
                    this.router.navigateByUrl('/login', { replaceUrl: true });
                    this.showMessageHttp('Su sesión ha caducado o los datos de acceso no son correctos');
                }

                return throwError(error);
            }));
    }

    public async showMessageHttp(text: string) {
        const toast = await this.toastController.create({
            message: text,
            duration: 9000,
            color: 'danger'
        });
        toast.present();
    }


}
